import { schema } from 'normalizr';
import { MentoringProgramGoalItem } from '../models/mentoring-program-goal-items';

export const MentorshipProgramGoalItemSchema = new schema.Entity<MentoringProgramGoalItem>('mentorshipProgramGoalItems');

export const MentorshipProgramGoalItemsSchema = new schema.Array(
  MentorshipProgramGoalItemSchema,
);
